import { render } from "./Personio.vue?vue&type=template&id=34dcd4ed"
import script from "./Personio.vue?vue&type=script&lang=js"
export * from "./Personio.vue?vue&type=script&lang=js"

import "./Personio.vue?vue&type=style&index=0&id=34dcd4ed&lang=scss"

import exportComponent from "/Users/david.haas/Documents/Projects/VSC/ommax-employer-branding-lp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__